import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";
import { Link } from "react-router-dom";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../utils/utils";
import TabelaFaculdade from "./TabelaFaculdade";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado) {
            await this.getDados();
        }
    }

    getDados = async (isAcumulado) => {

        let url = this.state.isAcumulado ? "/consulta?tipo=acumulado" : "/consulta?tipo=mes";
        let dados = await api.get(url);
        dados = dados.data.dados;
        this.setState({ dados });

        //let url = this.state.isAcumulado ? "/json/acumulado.json" : "/json/dados.json";
        //let dados = await fetch(url).then(res => res.json()).then(res => res);
        //this.setState({ dados });
    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    calculaTotal = (dados, isNotTotalGeral=true) => {
        
        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
        }

        if(dados) {
            Object.keys(dados.modalidades).map((modalidade, i) => {
                if(isNotTotalGeral) {
                    if(modalidade.indexOf("91 Pós") > -1 || modalidade.indexOf("41 Gra") > -1 || modalidade.indexOf("87 Cur") > -1) {
                        return;
                    };
                }
                total["matricula_regimental"]     += dados.modalidades[modalidade]["matricula_regimental"]
                total["matricula_nao_regimental"] += dados.modalidades[modalidade]["matricula_nao_regimental"]
                total["matricula_pago"]           += dados.modalidades[modalidade]["matricula_pago"]
                total["hora_regimental"]          += dados.modalidades[modalidade]["hora_regimental"]
                total["hora_nao_regimental"]      += dados.modalidades[modalidade]["hora_nao_regimental"]
                total["hora_pago"]                += dados.modalidades[modalidade]["hora_pago"]
            });
        }

        return total;

    }

    render() {
        let { dados, mesSelecionado, radioChecked } = this.state;
        let totais;
        return (
            <Fragment>

                <div class="card">
                    <div class="card-header">
                        Opções
                    </div>
                    <div class="card-body">

                        <Select selectMes={this.selectMes} selecionado={mesSelecionado} />
                        <Radio onChange={this.onChange} radioChecked={radioChecked} />
                        {/*
                        <Link to={location => (
                            {
                                ...location,
                                pathname: `/producaoep/upload`,
                                anterior: window.location.pathname || "/unidade",
                            }
                        )}>
                            <button className="btn btn-primary mt-3">Upload</button>
                        </Link>
                        */}

                    </div>
                </div>

                <div>
                    <Tabs defaultActiveKey={"DR"}>

                        {dados[mesSelecionado] && dados[mesSelecionado].map((valor, i) => {

                            let sigla = utils.verificaSiglaUnidade(valor.unidade);
                            let total = this.calculaTotal(valor);
                            let totalGeral = this.calculaTotal(valor, false);

                            return (
                                <Tab eventKey={sigla} title={sigla}>
                                    
                                    <Fragment>
                                        <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th colSpan="9" className="text-center">{valor.unidade}</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="4">Modalidades</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="4" className="text-center">Matrículas</th>
                                                    <th colSpan="4" className="text-center">Horas</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="4" className="text-center">Realizado (<span style={{textTransform: "uppercase"}}>{mesSelecionado}</span>) </th>
                                                    <th colSpan="4" className="text-center">Realizado (<span style={{textTransform: "uppercase"}}>{mesSelecionado}</span>) </th>
                                                </tr>
                                                <tr>
                                                    {/*<th>Modalidades</th>*/}
                                                    <th>Matrículas Regimental</th>
                                                    <th>Matrículas Não-Regimental</th>
                                                    <th>Matrículas Pagas</th>
                                                    <th>Total</th>
                                                    <th>Hora Regimental</th>
                                                    <th>Hora Não-Regimental</th>
                                                    <th>Hora Pagas</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(valor.modalidades).map((modal, j) => {

                                                    // Verifica Faculdade
                                                    if(modal.indexOf("91 Pós") > -1 || modal.indexOf("41 Gra") > -1 || modal.indexOf("87 Cur") > -1) return;

                                                    return (
                                                        <tr>
                                                            <td style={{ backgroundColor: "#c5c0ad" }}>{modal}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"] + valor.modalidades[modal]["matricula_nao_regimental"] + valor.modalidades[modal]["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valor.modalidades[modal]["hora_pago"] + valor.modalidades[modal]["hora_nao_regimental"] + valor.modalidades[modal]["hora_regimental"])}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                {
                                                    sigla !== "FACULDADE"
                                                    ?
                                                    <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad"  }}>
                                                        <td>Total</td>
                                                        <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                                                    </tr>
                                                    :
                                                    <TabelaFaculdade {...this.state} />
                                                }
                                                {
                                                    sigla === "DR" 
                                                    ?
                                                    <Fragment>
                                                        <TabelaFaculdade {...this.state} />
                                                        <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                                                            <td>Total Geral</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"] + totalGeral["matricula_nao_regimental"] + totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"] + totalGeral["hora_nao_regimental"] + totalGeral["hora_regimental"])}</td>
                                                        </tr>
                                                    </Fragment>
                                                    :
                                                    null
                                                }
                                            </tbody>
                                        </table>
                                    </Fragment>

                                </Tab>
                            )
                        })}

                    </Tabs>
                </div>

            </Fragment>
        )
    }
}